define([], function() 
{
	
	var observerPattern = (function() {


		function ObserverList() {
		  this.observerList = [];
		}

		ObserverList.prototype.add = function(obj) {
		  this.observerList.push(obj);
		};

		ObserverList.prototype.count = function() {
		  return this.observerList.length;
		};

		ObserverList.prototype.get = function(index) {
		  if(index > -1 && index < this.observerList.length) {
		    return this.observerList[index];
		  }
		};

		ObserverList.prototype.indexOf = function(obj, startIndex) {
		  var i = startIndex || 0;
		  
		  while(i < this.observerList.length) {
		    if(this.observerList[i] === obj) {
		      return i;
		    }
		    
		    i++;
		  }
		  
		  return -1;
		};

		ObserverList.prototype.removeAt = function(index) {
		  this.observerList.splice(index, 1);
		};

		function Subject() {
		  this.observers = new ObserverList();
		}

		Subject.prototype.addObserver = function(obj) {
		  this.observers.add(obj);
		};

		Subject.prototype.removeObserver = function(obj) {
		  this.observers.removeAt(this.observers.indexOf(obj, 0));
		};

		Subject.prototype.notify = function(context) {
		  
		  var observersCount = this.observers.count();
		  
		  for(var i = 0; i < observersCount; i++) {
		    this.observers.get(i).update(context);
		  }
		};

		function Observer() {
		  
		}

		Observer.prototype.update = function(context) {

		};
				
		var publicObj = {
			getNewSubject: function() {
				return new Subject();
			},
			
			getNewObserver: function() {
				return new Observer();
			}
		};
		

		return publicObj;

	})();

	
	return observerPattern;

});


/***
var objSubject = {
state: 1,

changeState: function() {
  
  this.state = 5;
  
  this.notify(this.state);
}

};

objSubject = $.extend(true, new Subject(), objSubject);

var observer1 = { 
lala: 'test1',

update: function(context) {
  console.log('observer1 update: ' + context);
}
};

var observer2 = { 
lala: 'test1',

update: function(context) {
  console.log('observer2 update: ' + context);
}
};

observer1 = $.extend(true, new Observer(), observer1);
observer2 = $.extend(true, new Observer(), observer2);

objSubject.addObserver(observer1);
objSubject.addObserver(observer2);

objSubject.changeState();
***/